import { useQuery } from "@tanstack/react-query";
import * as req from "@script/req.ts";
import { useLoginUser } from "@hooks/useAuth.ts";
import { useGroupStore } from "@store/groupStore.ts";

export function useRosterSubmissionQuery({
  year,
  month,
  groupId,
}: {
  year: number | null | undefined;
  month: number | null | undefined;
  groupId: string | null | undefined;
}) {
  const loginUser = useLoginUser();
  const { selectedGroupId: selectedGroupIdFromStore } = useGroupStore();

  const isAdmin = !!(
    loginUser?.EmpAuthGbn === "ADM" || loginUser?.is_master_admin
  );

  const effectiveGroupId = isAdmin
    ? (groupId ?? selectedGroupIdFromStore ?? undefined)
    : undefined;

  return useQuery<{ submitted_nurses: string[] }>({
    queryKey: ["ROSTER_SUBMISSION", year, month, effectiveGroupId],
    queryFn: async () => {
      if (!year || !month) {
        throw new Error("Year and month are required");
      }
      const validGid =
        effectiveGroupId &&
        effectiveGroupId.trim() !== "" &&
        effectiveGroupId !== "null"
          ? effectiveGroupId
          : undefined;

      if (isAdmin && !validGid) {
        // 관리자인데 유효한 그룹 ID가 없으면 빈 배열 반환
        return { submitted_nurses: [] };
      }

      return await req.roster_submission(year, month, validGid);
    },
    enabled: !!year && !!month,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 1,
    retryDelay: 1000,
  });
}
